<template>
  <layout-main-inner title="行业类别">
    <layout-card-wrap class="el-card-flex">
      <div style="display: flex;">
        <forms ref="forms"
          @emit:task="formTask" />
        <detail v-show="current"
          ref="detail" />
      </div>
    </layout-card-wrap>
  </layout-main-inner>
</template>

<script>
import Detail from './busi/detail.vue'
import Forms from './busi/form.vue'
export default {
  name: 'industry-index',
  components: { Forms, Detail },
  props: {},
  data () {
    return {
      current: ''
    }
  },
  watch: {},
  computed: {},
  methods: {
    formTask (obj) {
      this.current = obj.classId
      this.$nextTick(() => {
        this.$refs.detail.getcategorytemplate(obj)
      })
    }
  },
  created () { },
  mounted () { }
}
</script>
<style lang="stylus"></style>
